import { render, staticRenderFns } from "./file-upload-allowed-files-details.vue?vue&type=template&id=359091c0&scoped=true"
import script from "./file-upload-allowed-files-details.vue?vue&type=script&lang=js"
export * from "./file-upload-allowed-files-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359091c0",
  null
  
)

export default component.exports